import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import { useAIAssistant } from "./AIAssistantProvider";
import { AI_ASSISTANT_BLUE } from "./constants";

/**
 * Floating AI Assistant launcher — replaces the previous settings gear FAB.
 */
export default function AIAssistantLauncher() {
  const { isOpen, toggle } = useAIAssistant();

  if (isOpen) return null;

  return (
    <Tooltip title="Open AI Assistant" placement="left">
      <Box
        role="button"
        tabIndex={0}
        aria-label="Open AI Assistant"
        aria-expanded={false}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle();
          }
        }}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "3.25rem",
          height: "3.25rem",
          position: "fixed",
          right: "2rem",
          bottom: "2rem",
          zIndex: 1300,
          cursor: "pointer",
          borderRadius: "50%",
          color: "#ffffff",
          background: `linear-gradient(135deg, ${AI_ASSISTANT_BLUE} 0%, #3b82f6 100%)`,
          boxShadow: "0 12px 28px rgba(0, 97, 254, 0.38)",
          border: "1px solid rgba(255,255,255,0.25)",
          transition: "right 0.25s ease, transform 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 16px 32px rgba(0, 97, 254, 0.45)",
          },
          "&:focus-visible": {
            outline: "2px solid #93c5fd",
            outlineOffset: 3,
          },
        }}
      >
        <AutoAwesomeRoundedIcon fontSize="small" />
      </Box>
    </Tooltip>
  );
}
